import { IBaseResponse } from "@nkr/models/base-response";
import { IArrayResponse } from "@nkr/store/application";
import { AuthActionCreators } from "@nkr/store/authorization";
import { IApplicationState } from "@nkr/store/index";
import { Dispatch } from "react-redux";

export interface IOpoSemesterPayable {
    opoId                   : number,
    opoAlias                : string,
    opoHasAchOnFile         : boolean,
    transplantYear          : number,
    transplantSemester      : number,
    semesterStartDateTime   : string,
    semesterEndDateTime     : string,
    transplantCount         : number,
    totalInvoiced           : number,
    paymentAmount           : number,
    paymentDateTime         : string,
    paymentAchConfirmation  : string,
    daysOutstanding         : number
}

export const ActionsAdminOpoPayable = {
    getOpoPayables: (isPaid: boolean, hasAch: boolean) => (dispatch: Dispatch<IApplicationState>): Promise<IArrayResponse<IOpoSemesterPayable>> => {
        var options = {
            url: `${__API__}/billing/opo-payment?isPaid=${isPaid}&hasAch=${hasAch}`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IArrayResponse<IOpoSemesterPayable>) => {
            return Promise.resolve(response);
        });
    },

    updateOpoPayable: ( payable : IOpoSemesterPayable) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url  : `${__API__}/billing/opo-payment`,
            data : payable
        };

        return dispatch(AuthActionCreators.apiPut(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    }
};